export default {
    'me.title': '会員情報',
    'me.line_id': 'LINE ID',
    'me.member_card_number': '会員カード番号',
    'me.education_background': '学歴',
    'me.habit': '趣味・好み',
    'me.register_full': '正式会員として登録',
    'me.modify': '会員情報を変更',
} as Record<string, string>;
